import React, { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";

import LeftMenu from "../components/LeftMenu";
import MobileMenu from "../components/MobileMenu";
import PlyrVideoPlayer from "../components/PlyrVideoPlayer";
import useFontSize from "../hooks/useFontSize";
import apiService from "../services/api";

const readList = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.channels)) return data.channels;
  if (Array.isArray(data?.liveTv)) return data.liveTv;

  return [];
};

const streamFor = (item, playlist) => {
  let streamUrl = item.streamUrl || item.stream_url || item.hlsStreamUrl;

  if (
    !streamUrl &&
    (item.mediaId || item.id) &&
    playlist?.url &&
    playlist?.username &&
    playlist?.password
  ) {
    const baseUrl = playlist.url.replace(/\/$/, "");

    streamUrl = `${baseUrl}/${playlist.username}/${playlist.password}/${item.mediaId || item.id}`;
  }

  if (streamUrl && !String(streamUrl).startsWith("http")) {
    try {
      streamUrl = atob(streamUrl);
    } catch {
      // Keep the original value when it is not base64.
    }
  }

  return streamUrl;
};

const WebPlayerWatchedTv = () => {
  useFontSize();
  const location = useLocation();
  const profile =
    location.state?.profile ||
    JSON.parse(sessionStorage.getItem("selectedProfile") || "{}");
  const playlist =
    location.state?.playlist ||
    JSON.parse(localStorage.getItem("selectedPlaylist") || "{}");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [player, setPlayer] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const response = await apiService.webPlayerRequest(
          "/v2/recently-watched/live-tv?limit=100"
        );

        if (!cancelled) setItems(readList(response?.data));
      } catch {
        if (!cancelled) setError("Could not load recently watched TV.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  const play = (item) => {
    const streamUrl = streamFor(item, playlist);

    if (!streamUrl) return;

    setPlayer({
      url: streamUrl,
      title: item.name || item.title || "Live TV",
      item,
    });
  };

  return (
    <div className="min-h-screen">
      <MobileMenu />
      <LeftMenu activeMenuItem="live" playlist={playlist} profile={profile} />
      <div className="min-w-0 pb-12 pl-20 pr-4 pt-12 lg:pl-[calc(4rem+30px)] lg:pr-8 xl:pl-[calc(5rem+30px)]">
        <h1 className="mb-8 text-3xl font-bold text-white">
          Recently Watched TV
        </h1>
        {loading && <p className="text-gray-400">Loading...</p>}
        {error && <p className="text-gray-400">{error}</p>}
        {!loading && !error && items.length === 0 && (
          <p className="text-gray-400">No recently watched channels.</p>
        )}
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5">
          {items.map((item, idx) => {
            const logo = item.logoPath || item.posterPath || item.logo;

            return (
              <button
                className="lunova-card-host text-left"
                key={item.mediaId || item.id || idx}
                type="button"
                onClick={() => play(item)}
              >
                <div
                  className="lunova-card is-fixed-radius flex aspect-video items-center justify-center rounded-xl bg-white/10 p-4"
                  style={{ "--card-radius": "12px" }}
                >
                  {logo ? (
                    <img
                      alt=""
                      className="max-h-16 max-w-full object-contain"
                      src={logo}
                    />
                  ) : (
                    <span className="text-white">{item.name}</span>
                  )}
                </div>
                <p className="mt-2 truncate text-center text-sm font-semibold text-white">
                  {item.name || item.title}
                </p>
              </button>
            );
          })}
        </div>
      </div>
      {player && (
        <PlyrVideoPlayer
          isOpen
          mediaId={player.item.mediaId || player.item.id}
          mediaType="livetv"
          streamUrl={player.url}
          title={player.title}
          onClose={() => setPlayer(null)}
        />
      )}
    </div>
  );
};

export default WebPlayerWatchedTv;
